import { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { api, formatApiError } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { KeyRound, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (password.length < 6) { setErr('La password deve avere almeno 6 caratteri'); return; }
    if (password !== confirm) { setErr('Le password non coincidono'); return; }
    setBusy(true);
    try {
      const { data } = await api.post('/auth/password/reset', { token, password });
      // Persist token per auto-login
      if (data.access_token) localStorage.setItem('agn_token', data.access_token);
      if (refresh) await refresh();
      toast.success('Password aggiornata — accesso effettuato');
      nav('/dashboard');
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] max-w-md mx-auto px-6 lg:px-10 py-20">
      <Link to="/login" className="text-sm text-muted-foreground link-underline inline-flex items-center gap-1 mb-8">
        <ArrowLeft size={14}/> Login
      </Link>
      <form onSubmit={submit} data-testid="reset-form" className="rounded-2xl border border-border p-8 md:p-10 bg-card space-y-5">
        <div className="w-12 h-12 rounded-xl bg-foreground text-background grid place-items-center">
          <KeyRound size={20}/>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-terracotta mb-2">Nuova password</div>
          <h1 className="font-display text-3xl tracking-tight">Scegli una nuova password</h1>
          <p className="mt-3 text-sm text-muted-foreground">Almeno 6 caratteri. Ti consigliamo di usare una combinazione di lettere, numeri e simboli.</p>
        </div>
        <div className="space-y-2">
          <Label>Nuova password</Label>
          <Input type="password" value={password} onChange={e=>setPassword(e.target.value)} required autoFocus minLength={6} data-testid="reset-password"/>
        </div>
        <div className="space-y-2">
          <Label>Conferma password</Label>
          <Input type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} required minLength={6} data-testid="reset-confirm"/>
        </div>
        {err && <div className="text-sm text-destructive">{err}</div>}
        <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full rounded-full h-11">
          {busy ? 'Aggiornamento…' : 'Imposta nuova password'}
        </Button>
      </form>
    </div>
  );
}
